
import { Button } from "@/components/ui/button";
import { X } from "lucide-react";

interface StampUploadProps {
  stamp: string | null;
  onStampUpload: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onStampRemove: () => void;
}

const StampUpload = ({ stamp, onStampUpload, onStampRemove }: StampUploadProps) => {
  return (
    <div className="border-t pt-4">
      <h3 className="font-semibold mb-2 text-sm">Company Stamp (Required):</h3>
      <div className="grid grid-cols-2 gap-4">
        <div className="space-y-2">
          <input
            type="file"
            accept="image/*"
            onChange={onStampUpload}
            className="text-sm file:mr-4 file:py-2 file:px-4 file:rounded-md file:border-0 file:text-sm file:font-medium file:bg-primary file:text-primary-foreground hover:file:bg-primary/90"
          />
          <p className="text-xs text-muted-foreground">
            Upload company stamp (PNG, JPG)
          </p>
        </div>
        {stamp && (
          <div className="relative border border-border rounded-lg p-4 flex items-center justify-center bg-card dark:bg-card">
            <Button
              variant="ghost"
              size="icon"
              className="absolute -top-2 -right-2 h-6 w-6 rounded-full bg-destructive text-destructive-foreground hover:bg-destructive/90"
              onClick={onStampRemove}
            >
              <X className="h-4 w-4" />
            </Button>
            <img 
              src={stamp} 
              alt="Company stamp" 
              className="max-h-24 object-contain"
            />
          </div>
        )}
      </div>
    </div>
  );
};

export default StampUpload;
